






































import { Vue, Component, Prop } from 'vue-property-decorator';
import CommonDialog from '../organisms/CommonDialog.vue';
import QRCode from 'qrcode';
import isMobile from 'ismobilejs';
import { ContextDataService } from '../../biz/remote/ContextDataService';
import { Session } from '../../utils/Session';

@Component({ components: { CommonDialog } })
export default class LineOfficialConnectionDialog extends Vue {
  @Prop({ default: 'stu' })
  private type!: 'stu' | 'tea';

  // 運営との連絡LINE
  private qr_img = '';

  // 通知のLIEN公式
  private notify_qr_img = location.host === 'localhost:3001' ? 'https://qr-official.line.me/sid/L/822snuix.png' : 'https://qr-official.line.me/sid/L/954xwakz.png';

  get building() {
    return Session.getSessionBuildingId();
  }

  get isCO() {
    return Session.isCircleOBuilding();
  }

  get title() {
    if (this.building === 'co01') {
      return 'LINEをインストールしたスマートフォンで以下の2つのQRコードで、両方を友達追加してください!';
    } else {
      return 'LINEをインストールしたスマートフォンで以下のQRコードを友達追加してください!';
    }
  }

  openAdminLineConnectionUrl() {
    window.open(this.url, '_blank');
  }

  openNotifyLineConnectionUrl() {
    window.open('https://lin.ee/NrSlyql', '_blank');
  }

  private get url() {
    let type_url = '';
    if (this.type === 'stu') {
      // 生徒はデフアカオンラインとデフアカデミーで分岐
      if (this.building === 'co01') {
        type_url = 'https://lin.ee/PMtIjxz'; // デフアカオンライン
      } else {
        type_url = 'https://lin.ee/20TYqWTjP'; // デフアカデミー
      }
    } else {
      // teacher はCircleOしか通知しない
      type_url = 'https://lin.ee/0XlxmgO';
    }

    const width = 200;
    QRCode.toDataURL(type_url, { width: width, margin: 3 }).then((qr) => {
      this.qr_img = qr;
    });
    return type_url;
  }

  public async show() {
    (this.$refs['dialog'] as CommonDialog).show();
  }

  public close() {
    (this.$refs['dialog'] as CommonDialog).hide();
  }

  async done() {
    const biz = new ContextDataService();
    await biz.setIsSetOffcialLineAt(Session.getSessionUserId(), true);
    this.close();
  }

  connectOfficial() {
    window.open(this.url, '_blank');
    console.log('connect offical');
  }
}
